import LeadSourcesAPI from '../../api/leadSources';

const state = {
  records: [],
  uiFlags: { isFetching: false, isCreating: false, isUpdating: false, isDeleting: false },
};

const getters = {
  getLeadSources: $state => $state.records,
  getActiveLeadSources: $state => $state.records.filter(s => s.active),
  getUIFlags: $state => $state.uiFlags,
  getLeadSourceById: $state => id => $state.records.find(s => s.id === Number(id)),
};

const mutations = {
  SET_LEAD_SOURCES($state, records) { $state.records = records; },
  ADD_LEAD_SOURCE($state, record) { $state.records.push(record); },
  UPDATE_LEAD_SOURCE($state, record) {
    const i = $state.records.findIndex(r => r.id === record.id);
    if (i !== -1) $state.records.splice(i, 1, record);
  },
  DELETE_LEAD_SOURCE($state, id) {
    $state.records = $state.records.filter(r => r.id !== id);
  },
  SET_UI_FLAG($state, flag) { $state.uiFlags = { ...$state.uiFlags, ...flag }; },
};

const actions = {
  async fetch({ commit }) {
    commit('SET_UI_FLAG', { isFetching: true });
    try {
      const { data } = await LeadSourcesAPI.get();
      commit('SET_LEAD_SOURCES', data.payload);
    } finally {
      commit('SET_UI_FLAG', { isFetching: false });
    }
  },
  async create({ commit }, payload) {
    commit('SET_UI_FLAG', { isCreating: true });
    try {
      const { data } = await LeadSourcesAPI.create({ lead_source: payload });
      commit('ADD_LEAD_SOURCE', data);
      return data;
    } finally {
      commit('SET_UI_FLAG', { isCreating: false });
    }
  },
  async update({ commit }, { id, ...payload }) {
    commit('SET_UI_FLAG', { isUpdating: true });
    try {
      const { data } = await LeadSourcesAPI.update(id, { lead_source: payload });
      commit('UPDATE_LEAD_SOURCE', data);
      return data;
    } finally {
      commit('SET_UI_FLAG', { isUpdating: false });
    }
  },
  async delete({ commit }, id) {
    commit('SET_UI_FLAG', { isDeleting: true });
    try {
      await LeadSourcesAPI.delete(id);
      commit('DELETE_LEAD_SOURCE', id);
    } finally {
      commit('SET_UI_FLAG', { isDeleting: false });
    }
  },
};

export default { namespaced: true, state, getters, mutations, actions };
